import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
  fill?: string;
};

const MobileArrowRight: React.FC<Props> = ({ className, width = '24', height = '24', fill = '#1f1f1f' }) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={fill} viewBox="0 -960 960 960"><path d="M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v124q18 7 29 22t11 34v80q0 19-11 34t-29 22v404q0 33-23.5 56.5T680-40H280Zm0-80h400v-720H280v720Zm0 0v-720 720Zm40-400v80h166l-62 64 56 56 160-160-160-160-56 56 62 64H320Z"/></svg>
);

export default MobileArrowRight;
